import { axios } from '@/utils/request'

const session={
    init() {
        return axios({
            url: '/api/services/app/Session/GetCurrentLoginInformations',
            method: 'get'
        })
    }
}
export default session